import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { TellentRolesEffects } from './store/tellent-roles.effects';
import { TellentRolesNamespace, TellentRolesReducer } from './store/tellent-roles.store';

const provideTellentRolesState = provideState(TellentRolesNamespace, TellentRolesReducer);
const provideTellentRolesEffects = provideEffects(TellentRolesEffects);

export const tellentRolesData = [provideTellentRolesState, provideTellentRolesEffects];
